import z from 'zod';
import { SalesOrderWorkItemSchema } from './SalesOrderWorkItem';

export const SalesOrderWorkItemsResultSchema = z.record(
    z.string(), // SalesItem.id as string
    z.array(SalesOrderWorkItemSchema),
);

export type SalesOrderWorkItemsResult = z.infer<typeof SalesOrderWorkItemsResultSchema>;
